import React from 'react';
import { Breadcrumbs, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Header = () => {
    const handleClick = (event) => {
        event.preventDefault();
    };

    return (
        <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <div role="presentation" onClick={handleClick}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link
                            to="/appointment/today"
                            style={{
                                color: 'black',
                                opacity: '0.6',
                                textDecoration: 'none',
                            }}
                        >
                            Appointments
                        </Link>
                        <Link to="/appointment/new-appointment" style={{ color: 'black', textDecoration: 'none' }}>
                            New Appointment
                        </Link>
                    </Breadcrumbs>
                </div>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <Typography variant="h4" fontWeight={500}>
                    New Appointment
                </Typography>
            </Grid>
        </Grid>
    );
};

export default Header;
